import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(()=>({
        icon: {
            fontSize: '59px'
        }
    }));
export { useStyles };
